import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, openBlock } from "vue";
//#region src/components/ScalarIcon/logos/Astro.svg?component
var Astro_exports = /* @__PURE__ */ __exportAll({
	default: () => Astro_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1);
}
var Astro_default = { render: render$1 };
//#endregion
export { Astro_exports, Astro_default as default, render$1 as render };

//# sourceMappingURL=Astro.svg.virtual.js.map